









































































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import Editor from '@/components/Editor'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'VendorListingEditor'

  vue:
    props: ['lineItem']

    components: {
      Modal,
      Editor,
      RequestButton,
      LoadingIndicator,
    }

    data: ->
      modal:
        show: true
      dateRange: null
      quantity: null
      priceInDollars: null
      payoutInDollars: null
      brandProvides: null
      organizerInstructions: null
      isLocked: null

    computed:
      vendorListing: -> @ctxVendorListing @lineItem

      canUnlockOffer: ->
        !!(@$store.member.permissions || {}).accounting

    mounted: ->
      @initializeFields()

    methods:
      initializeFields: ->
        return unless @lineItem
        { available_dates } = @lineItem
        startDate = available_dates[0].starts_on
        endDate = available_dates[available_dates.length - 1].starts_on
        @dateRange = [startDate, endDate]
        @quantity = @lineItem.quantity
        @priceInDollars = @lineItem.price_in_dollars
        @payoutInDollars = @lineItem.payout_in_dollars
        @brandProvides = @lineItem.vars.brand_provides
        @organizerInstructions = @lineItem.vars.organizer_instructions
        @isLocked = @lineItem.locked

      adaptPayload: ->
        vendor_listing_id: @vendorListing.id
        atts:
          start_date: @dateRange[0]
          end_date: @dateRange[1]
          quantity: @quantity
          price_in_cents: @priceInDollars * 100
          payout_in_cents: @payoutInDollars * 100
          brand_provides: @brandProvides
          organizer_instructions: @organizerInstructions

      hiUnlockOffer: ->
        @isLocked = false

      hiSave: ->
        @$emit 'save', @adaptPayload()

      hiClose: ->
        @modal.show = false

    watch:
      'modal.show': (show) ->
        @$emit 'close' unless show

export default VueOptions.vue settings
